// import Test from "./components/Test";
import Layout from "./components/Layout/Layout";
// import Main from "./components/Main/main";

const App = () => {
  return (
    <Layout>
      {/* <Test /> */}
    </Layout>
  );
};

export default App;
